import React, { useState, useRef } from 'react';
import { BiMap, BiPhone, BiEnvelope } from 'react-icons/bi';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage('');
    setSuccessMessage('');

    const formData = {
      user_name: e.target.user_name.value,
      user_email: e.target.user_email.value,
      subject: e.target.subject.value,
      message: e.target.message.value,
    };

    const emailToYou = {
      user_name: formData.user_name,
      user_email: formData.user_email,
      subject: `Portfolio Contact: ${formData.subject}`,
      message: `
From: ${formData.user_name} (${formData.user_email})
Subject: ${formData.subject}

Message:
${formData.message}

---
Reply directly to this email to respond to ${formData.user_name}.
      `,
      to_name: 'Muhammad Jahanzaib Iqbal',
      to_email: 'jahanzaibiqbal150@gmail.com',
      reply_to: formData.user_email,
      from_name: `${formData.user_name} via Portfolio`,
      from_email: formData.user_email
    };

    const emailToVisitor = {
      to_name: formData.user_name,
      to_email: formData.user_email,
      from_name: 'Muhammad Jahanzaib Iqbal',
      from_email: 'jahanzaibiqbal150@gmail.com',
      subject: 'Thank you for contacting me!',
      message: `Hi ${formData.user_name},\n\nThank you for reaching out! I have received your message about "${formData.subject}" and will get back to you soon.\n\nYour original message:\n"${formData.message}"\n\nBest regards,\nMuhammad Jahanzaib Iqbal\nEmail: jahanzaibiqbal150@gmail.com\nPhone: +92 302 1164516`
    };

    Promise.all([
      emailjs.send('service_vzvkb4l', 'template_217slpd', emailToYou, 'bKWTRpr_lE4-dEDCz'),
      emailjs.send('service_vzvkb4l', 'template_217slpd', emailToVisitor, 'bKWTRpr_lE4-dEDCz')
    ])
      .then(() => {
        setLoading(false);
        setSuccessMessage('Thank you for your message! You will receive a confirmation email shortly, and I will get back to you soon.');
        if (form.current) {
          form.current.reset();
        }
      })
      .catch((error) => {
        console.error('EmailJS Error:', error);
        setLoading(false);
        setErrorMessage(`Error: ${error.text || error.message || 'Failed to send message'}. Please contact me directly at jahanzaibiqbal150@gmail.com`);
      });
  };

  return (
    <section id="contact" className="contact section">
      <div className="container section-title" data-aos="fade-up">
        <h2>Contact</h2>
        <p>Feel free to reach out to discuss opportunities for collaboration, whether for software development projects, Java applications, Flutter mobile apps, or any programming needs. I'm always open to new challenges and excited to contribute to innovative and impactful projects.</p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row gy-4">
          <div className="col-lg-5">
            <div className="info-wrap">
              <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="200">
                <BiMap className="icon flex-shrink-0" />
                <div>
                  <h3>Address</h3>
                  <p>Lahore, Punjab, Pakistan</p>
                </div>
              </div>

              <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="300">
                <BiPhone className="icon flex-shrink-0" />
                <div>
                  <h3>Call Me</h3>
                  <p><a href="tel:+923021164516">+92 302 1164516</a></p>
                </div>
              </div>

              <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="400">
                <BiEnvelope className="icon flex-shrink-0" />
                <div>
                  <h3>Email Me</h3>
                  <p><a href="mailto:jahanzaibiqbal150@gmail.com">jahanzaibiqbal150@gmail.com</a></p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-7">
            <form ref={form} onSubmit={sendEmail} className="php-email-form" data-aos="fade-up" data-aos-delay="200">
              <div className="row gy-3">
                <div className="col-md-6">
                  <label htmlFor="name-field" className="form-label">Your Name</label>
                  <input type="text" name="user_name" id="name-field" className="form-control" required />
                </div>

                <div className="col-md-6">
                  <label htmlFor="email-field" className="form-label">Your Email</label>
                  <input type="email" className="form-control" name="user_email" id="email-field" required />
                </div>

                <div className="col-12">
                  <label htmlFor="subject-field" className="form-label">Subject</label>
                  <input type="text" className="form-control" name="subject" id="subject-field" required />
                </div>

                <div className="col-12">
                  <label htmlFor="message-field" className="form-label">Message</label>
                  <textarea className="form-control" name="message" rows="6" id="message-field" required></textarea>
                </div>

                <div className="col-12 text-center">
                  {loading && <div className="loading d-block my-2 text-primary font-weight-bold">Sending message...</div>}
                  {errorMessage && <div className="error-message d-block alert alert-danger my-2">{errorMessage}</div>}
                  {successMessage && <div className="sent-message d-block alert alert-success my-2">{successMessage}</div>}

                  <button type="submit" disabled={loading} className="btn-send">Send Message</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
